import axios from "axios";

const useAuthApi = () => {
  const env = process.env.REACT_APP_ENV || "development";

  const baseURLMapping = {
    production: process.env.REACT_APP_BASE_URL_PRODUCTION,
    staging: process.env.REACT_APP_BASE_URL_STAGING,
    development: process.env.REACT_APP_BASE_URL_DEV, // Default to dev
  };

  const baseURL = `${
    baseURLMapping[env] || process.env.REACT_APP_BASE_URL_DEV
  }/auth`;

  const headers = {
    "Content-Type": "application/json",
    Authorization: `Bearer ${localStorage.getItem("access")}`,
  };

  const axiosInstance = axios.create({
    baseURL,
    headers,
  });

  const getUsersData = async (userId) => {
    try {
      const params = userId ? { user_id: userId } : {};
      const response = await axiosInstance.get("/users/", { params });
      return response.data;
    } catch (error) {
      throw error;
    }
  };

  const postUserData = async (userData) => {
    try {
      const response = await axiosInstance.post("/users/", userData);
      return response.data;
    } catch (error) {
      throw error;
    }
  };

  const patchUserData = async (id, updatedFields) => {
    try {
      const response = await axiosInstance.patch(
        `/users/${id}/`,
        updatedFields
      );
      return response.data;
    } catch (error) {
      throw error;
    }
  };

  const deleteUserData = async (id) => {
    try {
      const response = await axiosInstance.delete(`/users/${id}/`);
      return response.data;
    } catch (error) {
      throw error;
    }
  };

  const getUsersWithBranches = async ({
    userId = null,
    branchIds = [],
  } = {}) => {
    try {
      const params = {};
      if (userId) params.user_id = userId;
      if (branchIds.length) params.branch_id = branchIds.join(",");

      const response = await axiosInstance.get("/users/with-branches/", {
        params,
      });
      return response.data;
    } catch (error) {
      throw error;
    }
  };

  const setActiveBranch = async (branchId) => {
    try {
      const response = await axiosInstance.post(
        "/preferences/set-active-branch/",
        {
          branch_id: branchId,
        }
      );
      return response.data;
    } catch (error) {
      throw error;
    }
  };

  const getAvailableBranches = async () => {
    const response = await axiosInstance.get(
      "/preferences/available-branches/"
    );
    return response.data;
  };

  return {
    getAvailableBranches,
    getUsersData,
    postUserData,
    patchUserData,
    deleteUserData,
    getUsersWithBranches,
    setActiveBranch,
  };
};

export default useAuthApi;
